import { useSelector } from 'react-redux';
import { BEMBlock } from 'helpers/classnames';
import { Button } from 'palette/Button';
import { Header, Typography } from 'palette/Typography';
import { useConfig } from '@common/Hooks/useConfig';
import { useTranslate } from '@common/Translations';
import './NoFavouritesInfo.scss';

const BRANDS_PATH = 'brands-a-z';

export function NoFavouritesInfo() {
    const translate = useTranslate();
    const config = useConfig();

    const { department } = useSelector(state => state.listing);

    const [block, BEMElement] = BEMBlock('info-message');

    const { URLPrefix } = config;
    const hash = department ? `#${department}` : '';
    const link = `${URLPrefix}/${BRANDS_PATH}/${hash}`;

    return (
        <div className={block}>
            <Header
                className={BEMElement('header')}
                color="regular"
                level="5"
                weight="bold"
            >
                {translate('fav_brands_filter_title')}
            </Header>
            <Typography
                color="light"
                tagName="span"
                type="body"
            >
                {translate('fav_brands_filter_text')}
            </Typography>
            <div className={BEMElement('button-box')}>
                <Button
                    href={link}
                    size="small"
                    theme="secondary"
                >
                    {translate('fav_brands_all_brands')}
                </Button>
            </div>
        </div>
    );
}
